import { render, staticRenderFns } from "./PermanentFloatingDrawer.vue?vue&type=template&id=1611b5a2&"
import script from "./PermanentFloatingDrawer.vue?vue&type=script&lang=js&"
export * from "./PermanentFloatingDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports